import React from "react";
import PropTypes from "prop-types";
import { connect } from 'react-redux';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import CircularProgress from '@material-ui/core/CircularProgress';

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import logo from './emp.png'; // with import


import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import { loginRequest, loginReset } from "../../actions/loginPage";

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      employeeID: '',
      email: '',
      password: '',
      emailError: false,
      passwordError: false,
    };
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }

  componentDidUpdate(){
    if(this.props.loginData.success) {
      this.props.dispatch(loginReset())
      this.props.history.replace('/admin/dashboard', null);
    }
  }

  login(){

    if(!this.state.email) {
      this.setState({emailError: true});
      return;
    }

    if(!this.state.password) {
      this.setState({passwordError: true});
      return;
    }

    const payload = {
      email: this.state.email,
      password: this.state.password,
    }
  
    this.props.dispatch(loginRequest(payload));
  }

  handleTextChange(field, event) {
    const {value} = event.target
    this.setState({[field]: value, passwordError: false, emailError: false});
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <Snackbar
          place="tc"
          color="danger"
          message="Invalid Credentials, email or password is incorrect"
          open={!!this.props.loginData.errors}
          closeNotification={() => this.props.dispatch(loginReset())}
          close
        />
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={4}>
            <form>
              <Card login className={classes[this.state.cardAnimaton]}>
                {/* <div  style={{textAlign:"centre", margin: "10px"}}>
                  <center>
                    <img src={logo}  width="250"/>
                  </center>
                </div> */}
                <CardHeader
                  className={`${classes.cardHeader} ${classes.textCenter}`}
                  color="info"
                >

                  <h4 className={classes.cardTitle}>Log in</h4>
                  <div className={classes.socialLine}>
                  </div>
                </CardHeader>
                <CardBody>
                  <CustomInput
                    labelText="Employee ID"
                    id="firstname"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Face className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      ),
                      onChange: this.handleTextChange.bind(this, 'employeeID')
                    }}
                  />
                  <CustomInput
                    labelText="Email *"
                    id="email"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Email className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      ),
                      onChange: this.handleTextChange.bind(this, 'email')
                    }}
                    error={this.state.emailError}

                  />
                  <CustomInput
                    labelText="Password *"
                    id="password"
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Icon className={classes.inputAdornmentIcon}>
                            lock_outline
                          </Icon>
                        </InputAdornment>
                      ),
                      onChange: this.handleTextChange.bind(this, 'password'),
                      type: 'password'
                    }}
                    error={this.state.passwordError}

                  />
                </CardBody>
                <CardFooter className={classes.justifyContentCenter}>
                  {
                    this.props.loginData.loader ?
                     (<CircularProgress />) : 
                    (
                    <Button onClick={this.login.bind(this)} color="info" simple size="lg" block>
                      Let's Go
                    </Button>
                  )
                  }
                  
                </CardFooter>
              </Card>
            </form>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(loginPageStyle)(
  connect(state => ({ loginData: state.loginState }))(LoginPage)
  );
